import { checkKeyValid } from './checkRoleApply';

/**
 * Hàm replace string chứa các ký tự html
 * @param str String
 * @returns new string before replace
 */
export const convertLiquidTagToTagHtml = (str: string): string => {
  if (!str) {
    return str;
  }
  const entityMap: any = {
    '{{titleTag}}': 'titletag', // HOTFIX: P-SKU not find target selector
  };
  if (checkKeyValid('productLostTagForm')) {
    entityMap['<form action="/cart/add" method="post" enctype="multipart/form-data" id="{{formId}}"'] =
      '<formgf action="/cart/add" method="post" enctype="multipart/form-data" id="{{formId}}"';
  }
  Object.keys(entityMap).forEach((key) => {
    str = str.replaceAll(key, entityMap[key]);
  });
  return str;
};

/**
 * revertTagHtmlToLiquidTag
 */
export const revertTagHtmlToLiquidTag = (str: string): string => {
  if (!str) {
    return str;
  }
  const entityMap: any = {
    titletag: '{{titleTag}}', // HOTFIX: P-SKU not find target selector
  };
  if (checkKeyValid('productLostTagForm')) {
    // HOTFIX: Product not find target selector
    entityMap['<formgf action="/cart/add" method="post" enctype="multipart/form-data" id="{{formId}}"'] =
      '<form action="/cart/add" method="post" enctype="multipart/form-data" id="{{formId}}"';
    entityMap['</formgf>'] = '';
  }

  Object.keys(entityMap).forEach((key) => {
    str = str.replaceAll(key, entityMap[key]);
  });
  return str;
};
